import { distinctUntilChanged, type Observable } from 'rxjs'
import type { WorkspaceMember } from '@/features/iam/members/WorkspaceMember'
import type { UserData } from '@/features/iam/users/UserData'
import { filterNonNil } from '@/utils/rx-util'
import { createTrackingService } from '@/features/tracking/TrackingService'
import { combineLatestWith, take } from 'rxjs/operators'

export interface TrackingFeatureOptions {
  currentMember$: Observable<WorkspaceMember>
  currentUserData$: Observable<UserData>
  logout$: Observable<void>
}

export type TrackingFeature = ReturnType<typeof TrackingFeature>

export function TrackingFeature(options: TrackingFeatureOptions) {
  const trackingService = createTrackingService()

  options.currentMember$
    .pipe(
      filterNonNil(),
      distinctUntilChanged(),
      combineLatestWith(options.currentUserData$),
      take(1),
    )
    .subscribe(([member, userData]) => {
      trackingService.identify(member, userData)
    })

  options.logout$.pipe(take(1)).subscribe(() => trackingService.reset())

  return {
    trackingService,
  }
}
